import { createFileRoute } from '@tanstack/react-router';
import { Box, Text } from '@streamelements/frontend-ui';
import { SelectSimple } from '../../../../components/Select';
import { ensureOBSPresence } from '../../../../utils/ensureOBSPresence';

import { InputSourcePropertiesSelect } from '../../../../types/obs';
import { FormValues } from '../-form/form';
import { Controller, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { InputSourcePropertiesClientProvider } from '../-InputSourcePropertiesAdapter';

export const Route = createFileRoute('/_authenticated/onboarding/new-setup/_layout/setup-display-capture/')({
  component: DisplayCapture,
  loader: async () => {
    await ensureOBSPresence();

    const sourcePropertiesClient = await InputSourcePropertiesClientProvider.createSourcePropertiesClient();
    const monitorCaptureSource = await sourcePropertiesClient.getDisplayCaptureSourceType();

    console.log({
      sourcePropertiesClient,
      monitorCaptureSource,
    });

    return {
      displayCaptureOptions: monitorCaptureSource.properties.find(
        (property) => property.name === sourcePropertiesClient.displayCaptureIdPropertyName
      ) as InputSourcePropertiesSelect,
    };
  },
});

function DisplayCapture() {
  const { displayCaptureOptions } = Route.useLoaderData();
  const form = useFormContext<FormValues>();

  useEffect(() => {
    const fieldState = form.getFieldState('displayCaptureDeviceId');

    if (!fieldState.isDirty) {
      form.setValue('displayCaptureDeviceId', displayCaptureOptions.items[0]?.value ?? '');
    }
  }, [displayCaptureOptions]);

  return (
    <>
      <Box css={{ mb: '1rem' }}>
        <Text.Subtitle weight="bold" css={{ m: 0 }}>
          Display capture
        </Text.Subtitle>
        <Text.Body variant="caption" css={{ color: '$textPrimary50' }}>
          Select which display you would like to stream, you can change this to a game capture later
        </Text.Body>
      </Box>

      <Controller
        control={form.control}
        name="displayCaptureDeviceId"
        render={({ field }) => {
          return (
            <SelectSimple
              label="Display"
              options={new Map([...displayCaptureOptions.items.map((option) => [option.value, option.name] as const)])}
              value={field.value}
              placeholder="Select display"
              css={{ mb: '0.5rem' }}
              onChange={(value) => {
                field.onChange({
                  target: {
                    name: field.name,
                    value,
                  },
                });
              }}
            />
          );
        }}
      />
    </>
  );
}
